import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  profileCustomer,
  uploadCustomerPhoto,
  resetUpload,
  reset
} from '../../features/profile/profileSlice';
import CustomerCard from '../../components/CustomerCard';
import PasswordUpdateForm from '../../components/PasswordUpdateForm';
import { toast } from 'react-toastify';
import { Tab } from '@headlessui/react';
import { Icon } from '@iconify/react';
import usePageTitle from '../../hooks/usePageTitle';

function Profile() {
  usePageTitle('Profile');
  const { profile, isSuccess, isSuccessUpload, isErrorUpload, messageUpload } =
    useSelector(state => state.profile);

  const { user } = useSelector(state => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) navigate('/login');

    dispatch(profileCustomer());
  }, [dispatch, navigate, user]);

  useEffect(() => {
    if (isErrorUpload) {
      toast.error(messageUpload);
    }

    if (isSuccessUpload) {
      toast.success('Logo berhasil disimpan');
      dispatch(reset());
      dispatch(resetUpload());
      dispatch(profileCustomer());
    }
  }, [isErrorUpload, messageUpload, isSuccessUpload, dispatch]);

  const handleChangePhoto = file => {
    if (!file.name.match(/\.(jpg|jpeg|png)$/)) {
      toast.error('Format Tidak didukung');
      return false;
    }

    const formData = new FormData();
    formData.append('photo', file);

    dispatch(uploadCustomerPhoto(formData));
  };

  return (
    <main className='list-page profile-page p-4 sm:p-5 space-y-6'>
      <div className='list-page__header'>
        <div className='list-page__title-wrap'>
          <div className='list-page__title-copy'>
            <h1 className='list-page__title'>Profile</h1>
            <p className='list-page__subtitle'>
              Kelola informasi akun dan keamanan
            </p>
          </div>
        </div>
      </div>

      <div className='list-page__card profile-page__card'>
        <Tab.Group>
          <Tab.List className='profile-page__tabs'>
            <Tab className='profile-page__tab'>
              {({ selected }) => (
                <span className={selected ? 'is-active' : ''}>
                  <Icon
                    icon='solar:user-bold'
                    width={18}
                    color={selected ? '#1B2124' : '#6B7280'}
                  />
                  Informasi Akun
                </span>
              )}
            </Tab>
            <Tab className='profile-page__tab'>
              {({ selected }) => (
                <span className={selected ? 'is-active' : ''}>
                  <Icon
                    icon='solar:lock-password-bold'
                    width={18}
                    color={selected ? '#1B2124' : '#6B7280'}
                  />
                  Ganti Kata Sandi
                </span>
              )}
            </Tab>
          </Tab.List>

          <Tab.Panels>
            <Tab.Panel>
              {isSuccess ? (
                <CustomerCard
                  profile={profile}
                  handleChangePhoto={handleChangePhoto}
                />
              ) : (
                <div className='profile-page__loading'>Memuat profil...</div>
              )}
            </Tab.Panel>
            <Tab.Panel>
              <PasswordUpdateForm />
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </main>
  );
}

export default Profile;
